import * as React from 'react';
import styles from './index.less';
import FDrawer from '@/components/FDrawer';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FListFooter, { listStateAndListMore } from '@/components/FListFooter';
import * as AHooks from 'ahooks';
// import FIcons from '@/components/FIcons';
import FDropdown2 from '@/components/FDropdown2';
import FInput_Search from '@/components/FInput_Search';

interface FObjectSelectorDrawerProps {
  resourceTypeCode: string;

  onSelect?(obj: {
    bucketID: string;
    bucketName: string;
    objID: string;
    objName: string;
    sha1: string;
  }): void;

  onClose?(): void;
}

interface FObjectSelectorDrawerStates {
  visible: boolean;
  selectOptions: { text: string; value: string }[];
  selected: string;
  inputValue: string;
  objList: {
    bucketID: string;
    bucketName: string;
    objID: string;
    objName: string;
    sha1: string;
    resourceType: string[];
    updateTime: string;
  }[];
  objListState: 'loading' | 'noData' | 'noSearchResult' | 'loaded';
  objListMore: 'loading' | 'andMore' | 'noMore';
}

const initStates: FObjectSelectorDrawerStates = {
  visible: true,
  selectOptions: [
    {
      text: FI18n.i18nNext.tAuto('importobject_filter_buckets_all'),
      value: '_all',
    },
  ],
  selected: '_all',
  inputValue: '',
  objList: [],
  objListState: 'loading',
  objListMore: 'loading',
};

function FObjectSelectorDrawer({
  resourceTypeCode,
  onSelect,
  onClose,
}: FObjectSelectorDrawerProps) {
  const [$visible, set$visible] = React.useState<FObjectSelectorDrawerStates['visible']>(
    initStates['visible'],
  );
  const [$selectOptions, set$selectOptions] = React.useState<
    FObjectSelectorDrawerStates['selectOptions']
  >(initStates['selectOptions']);
  const [$selected, set$selected] = React.useState<FObjectSelectorDrawerStates['selected']>(
    initStates['selected'],
  );
  const [$inputValue, set$inputValue] = React.useState<FObjectSelectorDrawerStates['inputValue']>(
    initStates['inputValue'],
  );
  const [$objList, set$objList] = React.useState<FObjectSelectorDrawerStates['objList']>(
    initStates['objList'],
  );
  const [$objListState, set$objListState] = React.useState<
    FObjectSelectorDrawerStates['objListState']
  >(initStates['objListState']);
  const [$objListMore, set$objListMore] = React.useState<
    FObjectSelectorDrawerStates['objListMore']
  >(initStates['objListMore']);

  AHooks.useDebounceEffect(
    () => {
      loadData(true);
    },
    [$selected, $inputValue],
    {
      wait: 300,
    },
  );

  async function initData() {
    const params1: Parameters<typeof FServiceAPI.Storage.bucketList>[0] = {
      bucketType: 1,
    };

    const { data: data_bucketList } = await FServiceAPI.Storage.bucketList(params1);
    // console.log(data_bucketList, 'ddd9oiejflksdfjlk');

    set$selectOptions([
      {
        text: FI18n.i18nNext.tAuto('importobject_filter_buckets_all'),
        value: '_all',
      },
      ...data_bucketList.map((bl: any) => {
        return {
          text: bl.bucketName,
          value: bl.bucketName,
        };
      }),
    ]);

    // loadData();
  }

  async function loadData(restart: boolean = false) {
    let objectList: FObjectSelectorDrawerStates['objList'] = [];
    if (!restart) {
      objectList = [...$objList];
      set$objListMore('loading');
    } else {
      set$objListState('loading');
    }

    const {
      data: data_resourceType,
    }: {
      data: {
        formats: string[];
      };
    } = await FServiceAPI.Resource.getResourceTypeInfoByCode({
      code: resourceTypeCode,
    });
    // console.log(data_resourceType, 'data_resourceType isodjflksdjflkjlkj');

    const params: Parameters<typeof FServiceAPI.Storage.objectList>[0] = {
      bucketName: $selected,
      // resourceType: resourceType[resourceType.length - 1],
      resourceTypeCode: resourceTypeCode,
      isLoadingTypeless: 1,
      keywords: $inputValue,
      skip: objectList.length,
      limit: FUtil.Predefined.pageSize,
      // @ts-ignore
      extNames: data_resourceType.formats.join(',') || undefined,
    };
    const {
      data,
    }: {
      data: {
        dataList: {
          bucketId: string;
          bucketName: string;
          objectId: string;
          objectName: string;
          sha1: string;
          resourceType: string[];
          updateDate: string;
        }[];
        totalItem: number;
      };
    } = await FServiceAPI.Storage.objectList(params);
    // console.log(data, 'data sdiofj;sldkfjlsdjflksdjflkjlk');

    const newObjList: FObjectSelectorDrawerStates['objList'] = [
      ...objectList,
      ...data.dataList.map((d) => {
        return {
          bucketID: d.bucketId,
          bucketName: d.bucketName,
          objID: d.objectId,
          objName: d.objectName,
          sha1: d.sha1,
          resourceType: d.resourceType,
          updateTime: FUtil.Format.formatDateTime(d.updateDate, true),
        };
      }),
    ];
    // console.log(data, 'data09woi3e4jfsldkfsdjlfksdjflkj');
    const { state, more } = listStateAndListMore({
      list_Length: newObjList.length,
      total_Length: data.totalItem,
      has_FilterCriteria: $selected !== '_all' || $inputValue !== '',
    });
    set$objListState(state);
    set$objListMore(more);
    set$objList(newObjList);
  }

  return (
    <FDrawer
      title={'选择对象'}
      onClose={() => {
        set$visible(false);
      }}
      afterOpenChange={(visible) => {
        if (visible) {
          initData();
        } else {
          onClose && onClose();
        }
      }}
      open={$visible}
      width={820}
    >
      <div className={styles.filter}>
        {/* <FDropdownMenu
        options={$selectOptions}
        onChange={(value) => {
          set$selected((prevState) => {
            return value;
          });
        }}
      >
        <a>{($selectOptions.find((rs) => rs.value === $selected) as any).text}
          <FIcons.FDown style={{ marginLeft: 8, fontSize: 12 }} /></a>
      </FDropdownMenu> */}

        <FDropdown2
          autoArrow={true}
          // getPopupContainer={() => ref_Root.current as HTMLElement}
          menu={{
            selectedKeys: [$selected],
            items: $selectOptions.map((rs) => {
              return {
                key: rs.value,
                label: rs.text,
              };
            }),
            onClick: (value) => {
              set$selected(value.key);
            },
          }}
        >
          <span>{($selectOptions.find((rs) => rs.value === $selected) as any).text}</span>
        </FDropdown2>

        {/* <FComponentsLib.FInput.FSearch */}
        <FInput_Search
          // theme='dark'
          // debounce={300}
          value={$inputValue}
          onChange={(e) => {
            set$inputValue(e.target.value);
          }}
        />
      </div>
      {$objList.map((obj) => {
        return (
          <div key={obj.objID} className={styles.bucket}>
            <div>
              <div className={styles.title}>
                <div>
                  <FComponentsLib.FContentText singleRow={true} text={obj.objName} />
                </div>
              </div>
              <div style={{ height: 2 }} />
              <FComponentsLib.FContentText
                type={'additional2'}
                text={
                  (obj.resourceType.length > 0
                    ? `资源类型 ${FUtil.Format.resourceTypeKeyArrToResourceType(obj.resourceType)}`
                    : '未设置类型') + ` | 更新时间 ${obj.updateTime}`
                }
              />
            </div>
            <FComponentsLib.FRectBtn
              type='secondary'
              size='small'
              onClick={() => {
                onSelect && onSelect(obj);
                set$visible(false);
              }}
            >
              选择
            </FComponentsLib.FRectBtn>
          </div>
        );
      })}
      <FListFooter
        state={$objListMore}
        onClickLoadMore={() => {
          // dispatch<FetchExhibitListAction>({
          //   type: 'informalNodeManagerPage/fetchExhibitList',
          //   payload: {
          //     isRematch: false,
          //     isRestart: false,
          //   },
          // });
          loadData(false);
        }}
      />
    </FDrawer>
  );
}

export default FObjectSelectorDrawer;
